export enum TTSService {
  /** Hume's Text-To-Speech */
  DEFAULT = 'hume_ai',
  /** ElevenLab's Text-To-Speech */
  ELEVEN_LABS = 'eleven_labs',
  /** Play HT's Text-To-Speech */
  PLAY_HT = 'play_ht',
}
